<template>
  <div class="landing">
    <Main />
    <!-- <InstaOpen/> -->
    <!-- <TabContainer/> -->
    <References />
    <Example />
    <InterviewReview />
    <Row1 />
    <Row2 />
    <Row3 />
    <InspectionReview />
    <Row4 />
    <Price />
    <!-- <Promotion/> -->
    <!-- <Review /> -->
    <!--<Contacts/>-->
    <!-- <Downloads />  // 도입문의 퍼널 개선으로 인한 주석처리-->

    <LeadBanner />
    <!-- <Introduce/> -->
    <!-- <Youtube /> -->

    <!-- 쿼리 파라미터로 모달 열기 -->
    <LeadModal :show-modal.sync="showLeadModal" :source-route="modalSourceRoute" />
  </div>
</template>

<script>
import Main from '@/components/landing/Landing';
// import TabContainer from '@/components/landing/TabContainer';
// import Review from "@/components/landing/Reviews";
// import Contacts from '@/components/landing/Contacts';
// import Introduce from '@/components/landing/Introduce';
import Row1 from '@/components/landing/rows/Row1';
import Row2 from '@/components/landing/rows/Row2';
import Row3 from '@/components/landing/rows/Row3';
import Row4 from '@/components/landing/rows/Row4';
import Price from '@/components/landing/Price';
// import Promotion from '@/components/landing/Promotion'
// import Downloads from '@/components/landing/Downloads';
import LeadBanner from '@/components/lead/banner/LeadBanner';
import LeadModal from '@/components/lead/modal/LeadModal';
import References from '@/components/landing/References';
import Example from '@/components/landing/Example';
import InterviewReview from '../../components/landing/InterviewReview.vue';
import InspectionReview from '../../components/landing/InspectionReview.vue';
import { pushDataLayer } from '@/utils';

const scrollCheckPoint = { 0.25: 0, 0.5: 0, 0.75: 0, 0.9: 0 };

export default {
  name: 'Landing',
  components: {
    // InstaOpen,
    Main,
    // TabContainer,
    // Review,
    // Contacts,
    // Introduce,
    References,
    Row1,
    Row2,
    Row3,
    Row4,
    Price,
    // Promotion,
    Example,
    // Downloads,
    LeadBanner,
    LeadModal,
    InterviewReview,
    InspectionReview,
    // Youtube,
  },
  data() {
    return {
      showLeadModal: false,
      modalSourceRoute: 'storeLanding',
    };
  },
  methods: {
    handleScroll() {
      // 현재 스크롤된 위치 (px)
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      // 화면 높이 (px)
      const windowHeight = window.innerHeight;

      // 문서 전체 높이 (px)
      const docHeight = document.documentElement.scrollHeight;

      // 스크롤 진행률 (0 ~ 1)
      const scrollPercent = scrollTop / (docHeight - windowHeight);

      Object.keys(scrollCheckPoint).forEach(targetScrollPercent => {
        if (scrollPercent >= targetScrollPercent && scrollCheckPoint[targetScrollPercent] === 0) {
          scrollCheckPoint[targetScrollPercent] = 1;
          pushDataLayer({
            event: 'scrollDepthReached',
            page: 'storeLanding',
            scrollDepth: targetScrollPercent * 100,
          });
        }
      });
    },
    checkQueryParameters() {
      const urlParams = new URLSearchParams(window.location.search);
      const shouldOpenModal = urlParams.get('openLeadModal') === 'true' || urlParams.get('inquiry') === 'true';
      const utmCampaign = urlParams.get('utm_campaign');

      if (shouldOpenModal) {
        // GTM 중복 클릭 차단 플래그 먼저 설정
        sessionStorage.setItem('leadModalOpenedByQuery', 'true');

        // utm_campaign에 따라 sourceRoute 설정
        if (utmCampaign === 'serviceGuide') {
          this.modalSourceRoute = 'serviceGuide';
        } else {
          this.modalSourceRoute = 'storeLanding';
        }

        // 쿼리 파라미터 제거
        const newUrl = window.location.pathname;
        window.history.replaceState({}, '', newUrl);

        // 모달 열기
        this.$nextTick(() => {
          this.showLeadModal = true;

          // 5초 후 플래그 제거
          setTimeout(() => {
            sessionStorage.removeItem('leadModalOpenedByQuery');
          }, 5000);
        });
      }
    },
  },

  mounted() {
    this.checkQueryParameters();
    window.addEventListener('scroll', this.handleScroll);
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style scoped lang="scss">
* {
  font-family: 'Pretendard', 'Sans-serif';
}

::v-deep button {
  width: 220px;
  height: 48px;
  background-color: #000000;
  background-color: var(--default-color);
  color: #ffffff;
  color: var(--white-two-color);
  cursor: pointer;
  outlined: none;
  border: none;
  &.primary {
    background-color: #b00016;
    background-color: var(--primary-color);
  }
}

.landing {
  font-size: 15px;
  font-weight: 400;
  // letter-spacing: -1px;
  background-color: #ffffff;
  background-color: var(--white-two-color);
  max-width: 100vw;
  overflow-x: hidden;

  ::v-deep h1,
  .h1 {
    font-size: 40px !important;
  }

  ::v-deep h2,
  .h2 {
    font-size: 32px !important;
  }

  ::v-deep h3,
  .h3 {
    font-size: 27px !important;
  }

  ::v-deep h4,
  .h4 {
    font-size: 15px !important;
  }

  ::v-deep h5,
  .h5 {
    font-size: 14px !important;
  }
}

@media (max-width: 960px) {
  .landing {
    font-size: 14px;

    ::v-deep h1,
    .h1 {
      font-size: 28px !important;
    }
    ::v-deep h2,
    .h2 {
      font-size: 24px !important;
    }
    ::v-deep h3,
    .h3 {
      font-size: 18px !important;
    }
    ::v-deep h4,
    .h4 {
      font-size: 14px !important;
    }
    ::v-deep h5,
    .h5 {
      font-size: 13px !important;
    }
  }
}
</style>
